export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Ring om du har frågor – samtal behandlas alltid konfidentiellt',
        subtitleInfo1: 'Vi har också gjort en ',
        faq: 'FAQ',
        subtitleInfo2: ', där du kan hitta svar på de flesta frågor om ',
        subtitleInfo3: ' visselblåsarsystemet.',
    }
};
